import { PROPERTY_GRID_SUBJECT_PROPERTY, noop, schQueryParams } from '@aloft/toolkit-shared';
import { Button, Tooltip, Typography } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/prefer-sound-ui-box, aloft/no-sui-chakra, aloft/prefer-sound-ui-button
import { Box, Menu, MenuButton, MenuItem, MenuList } from '@aloft/toolkit-sui/chakra';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAddCompModals } from '../hooks/useAddCompModals.tsx';
import { selectEditablePropertyDataById } from '../redux/features/selectors/propertyDataSelectors/editablePropertyDataSelectors.ts';
import { useAppSelector } from '../redux/hooks.ts';
import { pathnameIsRentalComparables } from '../utils/pathnameIsRentalComparables.ts';
import { GuidedTourTooltip } from './GuidedTour/GuidedTourTooltip.tsx';
import { menuListProps, menuProps } from './MainHeader/consts.ts';

export const AddCompButtons = () => {
  const {
    addCompsModal,
    openAddCompsModal,
    addRecommendedCompsModal,
    openAddRecommendedCompsModal,
  } = useAddCompModals();

  const { pathname } = useLocation();
  const subjectEditableData = useAppSelector((state) =>
    selectEditablePropertyDataById(state, PROPERTY_GRID_SUBJECT_PROPERTY),
  );
  const showRecComps = useAppSelector(
    (state) =>
      state.order.propertyType &&
      ['singleFamilyResidence', 'townhouse'].includes(state.order.propertyType),
  );
  const onRentalComparablesPage = pathnameIsRentalComparables(pathname);

  const gla = subjectEditableData?.improvements?.gla;
  const siteArea = subjectEditableData?.site?.area;
  const isRecCompsDisabled = !subjectEditableData || !gla || !siteArea || siteArea.unitAmount === 0;

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    if (
      params.get(schQueryParams.enum.addComps) === 'true' ||
      params.get(schQueryParams.enum.filters) === 'true'
    ) {
      openAddRecommendedCompsModal();
    }
  }, [openAddRecommendedCompsModal]);

  return (
    <>
      {addRecommendedCompsModal}
      {addCompsModal}
      <Menu {...menuProps} placement="bottom-end">
        <MenuButton as={Box} style={{ cursor: 'pointer' }}>
          <GuidedTourTooltip
            text={[
              'Click `Add Comps` to add properties or pick a recommended comp.',
              'If you created your order by uploading an appraisal XML, Toolkit automatically brings in comps from that report.',
            ]}
            tourID="analysisTour"
            tourIndex={0}
            placement="left"
          >
            <Button
              variant="primary"
              size="sm"
              text="Add Comps"
              onClick={noop}
              rightIcon="arrow-down-s"
            />
          </GuidedTourTooltip>
        </MenuButton>
        <MenuList {...menuListProps} minWidth="100px" zIndex={1000}>
          {showRecComps && (
            <Tooltip
              label={
                isRecCompsDisabled ? (
                  <Typography variant="body2">
                    Please enter subject property&apos;s GLA and Lot Size to enable this feature.
                  </Typography>
                ) : undefined
              }
              isDisabled={!isRecCompsDisabled}
              placement="right"
            >
              <Box>
                <MenuItem
                  isDisabled={isRecCompsDisabled}
                  onClick={isRecCompsDisabled ? undefined : openAddRecommendedCompsModal}
                >
                  <Typography>
                    {onRentalComparablesPage ? 'Recommended Rental Comps' : 'Recommended Comps'}
                  </Typography>
                </MenuItem>
              </Box>
            </Tooltip>
          )}
          <MenuItem onClick={openAddCompsModal}>
            <Typography>Manually Add Comps</Typography>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};
